var pug = require("!./../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch1\u003Eテキストの部分拡大\u003C\u002Fh1\u003E\u003Cdiv class=\"zoom-wrapper\"\u003E\u003Cdiv class=\"text\"\u003E\u003Cdiv class=\"js-glass\"\u003ELorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem modi odio reiciendis sunt illo aut, rerum tempora, laborum expedita pariatur suscipit voluptatum. Cupiditate vel porro, aperiam sapiente perferendis ducimus aut?\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"js-glass-copy\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


/*****************
 ** WEBPACK FOOTER
 ** ./app/posts/idea04.pug
 ** module id = 186
 ** module chunks = 0
 **/